var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":this.firstImageUrl,"srcset":_vm.srcSet,"onload":"if(!(width=this.getBoundingClientRect().width))return;this.onload=null;this.sizes=Math.ceil(width/window.innerWidth*100)+'vw';"}})}
var staticRenderFns = []

export { render, staticRenderFns }